import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const SlideCard = styled.div`
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  aspect-ratio: 1342 / 751;

  @media ${responsiveMap.mobile} {
    aspect-ratio: 329 / 384;
    border-radius: 8px;
  }

  .ro-image-responsive {
    aspect-ratio: 1342 / 751;
    @media ${responsiveMap.mobile} {
      aspect-ratio: 329 / 384;
    }
  }
`;

export const SlideMedia = styled.div`
  position: absolute;
  inset: 0;
  background: #111;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const SlideOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.25) 40%,
    rgba(0, 0, 0, 0.6) 70%,
    rgba(0, 0, 0, 0.75) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px 20px;
`;

export const SlideCta = styled.div<{ available: boolean }>`
  cursor: ${({ available }) => (available ? "pointer" : "default")};

  text-decoration: ${({ available }) => (available ? "underline" : "none")};
`;
